import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { widthEm, isPortrait } from '../../utils/size';
import ThemeContext from '../../utils/theming';

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    ${props => props.desktopLinkImage && `max-width: 70%;`};
`;

export const Body = styled.div`
    flex: 1;
    margin: 1em 1em 0;
    display: flex;
    flex-direction: column;
`;

export const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: ${({ radialSlider }) =>
        radialSlider && isPortrait() ? 'column' : 'row'};
    margin-top: ${props => (props.scrollableDesign ? 0.5 : 1.5)}em;
    ${props =>
        props.scrollShadow && `box-shadow: inset 0 7px 9px -7px rgba(0, 0, 0, 0.15);`};
`;

export const RockTheVoteLabel = styled.div`
    font-size: 10px;
    color: ${({ color }) => color};
    margin-top: 12px;
    letter-spacing: 2px;
    font-family: Averta;
    font-weight: 800;
    cursor: pointer;
`;

const headerTextFontSize = (isLongTitle, answersLength, isRockTheVote) => {
    if (widthEm() < 30) {
        return isLongTitle && (answersLength > 3 || isRockTheVote) ? '18px' : '24px';
    } else if (widthEm() < 33) {
        return isLongTitle && (answersLength > 3 || isRockTheVote) ? '18px' : '26px';
    } else if (widthEm() < 38) {
        return isLongTitle && (answersLength > 3 || isRockTheVote) ? '22px' : '25px';
    } else if (widthEm() < 39.5) {
        return isLongTitle && (answersLength > 3 || isRockTheVote) ? '24px' : '26px';
    }
    return isLongTitle && (answersLength > 3 || isRockTheVote) ? '22px' : '28px';
};

const headerTextLineHeight = (isLongTitle, answersLength, isRockTheVote) => {
    if (widthEm() < 30) {
        return isLongTitle && (answersLength > 3 || isRockTheVote) ? '22px' : '26px';
    } else if (widthEm() < 33) {
        return isLongTitle && (answersLength > 3 || isRockTheVote) ? '24px' : '28px';
    } else if (widthEm() < 38) {
        return isLongTitle && (answersLength > 3 || isRockTheVote) ? '26px' : '30px';
    } else if (widthEm() < 39.5) {
        return isLongTitle && (answersLength > 3 || isRockTheVote) ? '28px' : '32px';
    }
    return isLongTitle && (answersLength > 3 || isRockTheVote) ? '30px' : '36px';
};

export const HeaderText = styled.div`
    background-color: white;
    margin-top: 24px;
    overflow: hidden;
    color: #333;
    font-weight: 300;
    font-size: ${props =>
        headerTextFontSize(props.isLongTitle, props.answersLength, props.isRockTheVote)};
    line-height: ${props =>
        headerTextLineHeight(
            props.isLongTitle,
            props.answersLength,
            props.isRockTheVote
        )};
`;

export const Sidebar = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    flex: 0 0 30%;
    margin-right: 1em;
    margin-left: 0.5em;

    @media (max-width: 30em) {
        display: none;
    }
`;

export const ContentContainer = styled.div`
    ${props =>
        props.scrollableDesign
            ? ` width: 100%;
                height: 100%;
                overflow-y: scroll;
                overflow-x: hidden;
                padding-right: 0.75em;
                form {
                    height: 70%;
                }
                `
            : ` flex: 1;
                margin-top: 0.5em;
            `}
    display: flex;
    flex-direction: column;

    form {
        padding-bottom: 10px;
        position: relative;
    }
`;

export const FindRepLink = styled.a`
    color: #008eff;
    font-weight: normal;
    cursor: pointer;
`;

export const ImageContainer = styled.div`
    display: flex;
`;

const DescriptionContainer = styled.p`
    object-fit: contain;
    font-family: Lato;
    line-height: 1.5;
    color: #333;
    margin-bottom: 0;
    word-break: break-word;
    font-size: 0.915em;

    span {
        font-weight: 800;
        color: ${({ theme }) => theme.colors.primary};
        cursor: pointer;
    }
`;

export const Description = props => (
    <DescriptionContainer theme={useContext(ThemeContext)} {...props} />
);

export const SidebarTitle = styled.h3`
    font-size: 1em;
    font-weight: bold;
    line-height: 1.25;
    color: #000;
    text-transform: capitalize;
    margin-top: 1em;
    margin-bottom: 0.25em;
`;

export const SidebarDescription = styled.p`
    font-size: 0.875em;
    line-height: 1.3;
    color: #333;
`;

export const NotYourRepInfo = styled.div`
    font-family: Lato;
    line-height: 1.33;
    font-weight: bold;
    visibility: visible;
    transition: visibility 0.1s;
    margin-bottom: -0.5em;
    ${props => (props.isUnderImage ? 'right: 0;' : 'right: 15px;')};
    ${props => (props.isUnderImage ? 'top: 6px;' : 'top: 60px;')};
    ${props => (props.isLocalRepLoading ? 'display: none;' : '')};
    ${props => (props.isUnderImage ? 'position: relative;' : 'position: absolute;')};
    ${props => (props.isUnderImage ? 'font-size: 12px;' : 'font-size: 10px;')};
    ${props => (props.isUnderImage ? 'z-index: 0;' : 'z-index: 1;')};
    ${props =>
        props.scrollableDesign &&
        ` position: relative;
          top: unset;
          right: unset;
          text-align: right;
          padding-top: 0.5em;
        `};

    &.focused {
        visibility: hidden;
    }

    ${() => (widthEm() <= 20 ? `font-size: 8.5px` : ``)};
`;

export const PhoneNumber = styled.a`
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    cursor: pointer;
    font-size: 18px;
`;

export const ContentContainerMobile = styled.div`
    display: flex;
    flex-direction: row;

    @media (min-width: 30em) {
        display: none;
    }
`;

export const ImageContainerMobile = styled.div`
    margin-right: 22px;
`;

export const ContentInnerMobile = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
    flex: 1;
`;

export const ContentTitle = styled.h2`
    font-size: 1.125em;
    font-weight: bold;
    line-height: 1.3;
    margin-top: 0;
    margin-bottom: ${props => (props.isHouseRep ? '23px' : '0px')};
`;

export const ContentDescription = styled.div`
    font-family: Averta;
    font-size: 22px;
    line-height: 26px;
    color: #333333;
    font-weight: normal;
    overflow: auto;
    max-height: 220px;

    @media (max-width: 30em) {
        max-height: 243px;
        margin-top: 12px;
    }
`;

export const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-top: 0.75em;
    position: absolute;
    bottom: 12px;
    left: 0;
    width: calc(100% - 15px);
    padding-left: 33.33%;

    ${props =>
        widthEm() <= 30
            ? `
        padding-left: 15px;
        bottom: ${props.isSinglePerson ? '12px' : '50px'};
      `
            : ``};

    > div {
        position: relative;
    }

    button {
        &.middleButton {
            margin-right: 1em;
        }

        &.submitButton {
            ${props => (props.skipFrontCard ? `margin-right: 0;` : '')};
            ${props =>
                props.isSubmitting && !props.isPhoneLinkClicked
                    ? `text-indent: -99999px;`
                    : ''};
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            display: none;
            top: 7px;
            right: ${props => (props.skipFrontCard ? `50%` : `25%`)};
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;

            ${props =>
                props.isSubmitting && !props.isPhoneLinkClicked ? `display: block` : ''};
        }
    }
`;
